export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";